/** Pure display helpers. No services, so components may use them freely. */

const UNITS = ['B', 'KB', 'MB', 'GB'];

export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined) {
    return '—';
  }
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${unit === 0 ? value : value.toFixed(1)} ${UNITS[unit]}`;
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) {
    return '—';
  }
  const parsed = new Date(iso);
  return Number.isNaN(parsed.valueOf()) ? iso : parsed.toLocaleString();
}

/** The tail of a uuid, which is all anyone reads off a screen. */
export function shortId(id: string | null | undefined): string {
  return id ? id.slice(-12) : '—';
}

/** `4 Oct 2026`, for a reader who wants the day rather than the second. */
export function formatDay(iso: string | null | undefined): string {
  if (!iso) {
    return '—';
  }
  const parsed = new Date(iso);
  return Number.isNaN(parsed.valueOf())
    ? iso
    : parsed.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}
